import { Modal } from "ui";

import { WatchVideoModalProps } from "../components.types";

import styles from "./WatchVideoModal.module.scss";

const WatchVideoModal = ({ isOpen, onClose, video }: WatchVideoModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      title={`Watch Video`}
      onClose={onClose}
      footer={<></>}
    >
      <div className={styles.watchVideoModal}>
        <video
          className={styles.watchVideoModal_video}
          src={video?.video?.url}
          controls
        />
      </div>
    </Modal>
  );
};

export default WatchVideoModal;
